import { useState } from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { PMDialog } from "../../../utils/PMDialog";

export function EvaluationLabelInfo({ label, infoKey, className = "" }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const title = t(`hse.evaluation.help.${infoKey}.title`);
  const body = t(`hse.evaluation.help.${infoKey}.body`);

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span>{label}</span>
      <button
        type="button"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen(true);
        }}
        className="inline-flex h-5 w-5 items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1463C7]"
        aria-label={t("hse.evaluation.help.open", { term: label })}
      >
        <InformationCircleIcon className="h-4 w-4" aria-hidden="true" />
      </button>
      <PMDialog open={open} onClose={() => setOpen(false)} title={title} size="md" closeOnOutsideClick>
        <p className="text-sm leading-6 text-slate-600 whitespace-pre-line">{body}</p>
      </PMDialog>
    </span>
  );
}
